import React, { useState, useRef, useEffect } from 'react';
import { ConstructorEventUpdateSQLStatus } from "../../../../Event/event";

export default function QuickSquareNear50() {
  const [number, setNumber] = useState('');
  const [x, setX] = useState(0);
  const [step2Visible, setStep2Visible] = useState(false);
  const [step3Visible, setStep3Visible] = useState(false);

  const [sq50, setSq50] = useState('');
  const [xval, setXval] = useState('');
  const [hundx, setHundx] = useState('');
  const [xsquare, setXsquare] = useState('');
  const [multiFeedback, setMultiFeedback] = useState('');

  const [finalAns, setFinalAns] = useState('');
  const [finalFeedback, setFinalFeedback] = useState('');

  const canvasRef = useRef(null);
  const confetti = useRef([]);

  const startGame = () => {
    const num = parseInt(number, 10);
    if (num < 40 || num > 60 || isNaN(num)) {
      alert('Try a number close to 50 (e.g., 47 to 55)');
      return;
    }
    setX(num - 50);
    setStep2Visible(true);
    setStep3Visible(false);
    setSq50('');
    setXval('');
    setHundx('');
    setXsquare('');
    setFinalAns('');
    setMultiFeedback('');
    setFinalFeedback('');
  };

  const checkSteps = () => {
    const correct = parseInt(sq50) === 2500 &&
      parseInt(xval) === x &&
      parseInt(hundx) === 100 * x &&
      parseInt(xsquare) === x * x;

    if (correct) {
      setMultiFeedback("✅ All correct! Let's find the square!");
      setStep3Visible(true);
    } else {
      setMultiFeedback('❌ Oops! One or more answers are wrong. Try again!');
      setStep3Visible(false);
    }
  };

  const checkFinal = () => {
    const final = 2500 + 100 * x + x * x;
    if (parseInt(finalAns) === final) {
      setFinalFeedback(`🎉 Woohoo! ${number}² = ${final}`);
      launchConfetti();
            const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
    } else {
      setFinalFeedback('❌ Try again. Remember to add 2500 + 100×x + x²');
    }
  };

  const launchConfetti = () => {
    confetti.current = [];
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    for (let i = 0; i < 200; i++) {
      confetti.current.push({
        x: Math.random() * canvas.width,
        y: Math.random() * -canvas.height,
        r: Math.random() * 6 + 4,
        d: Math.random() * 20 + 10,
        color: `hsl(${Math.random() * 360}, 100%, 70%)`
      });
    }
    animateConfetti(ctx, canvas);

    // Refresh the page after 2 seconds
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };

  const animateConfetti = (ctx, canvas) => {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    confetti.current.forEach(c => {
      ctx.beginPath();
      ctx.arc(c.x, c.y, c.r, 0, Math.PI * 2);
      ctx.fillStyle = c.color;
      ctx.fill();
      c.y += Math.cos(c.d / 10) + 2;
      c.x += Math.sin(c.d / 10);
    });
    requestAnimationFrame(() => animateConfetti(ctx, canvas));
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }, []);

  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <h1 style={styles.h1}>🐿️ Smarty says: Let's Square Near 50!</h1>
        <p>Enter a number close to 50 (e.g., 47 to 55)</p>
        <input
          type="number"
          value={number}
          onChange={e => setNumber(e.target.value)}
          style={styles.input}
        />
        <button onClick={startGame} style={styles.button}>Start</button>

        {step2Visible && (
          <div style={styles.step}>
            <p>What is 50²?</p>
            <input value={sq50} onChange={e => setSq50(e.target.value)} style={styles.input} />
            <p>What is x = number - 50?</p>
            <input value={xval} onChange={e => setXval(e.target.value)} style={styles.input} />
            <p>What is 100 × x?</p>
            <input value={hundx} onChange={e => setHundx(e.target.value)} style={styles.input} />
            <p>What is x × x?</p>
            <input value={xsquare} onChange={e => setXsquare(e.target.value)} style={styles.input} />
            <button onClick={checkSteps} style={styles.button}>Check Answers</button>
            <p style={{ ...styles.feedback, color: multiFeedback.includes('✅') ? 'green' : 'red' }}>{multiFeedback}</p>
          </div>
        )}

        {step3Visible && (
          <div style={styles.step}>
            <p>Now add them: 50² + 100×x + x²</p>
            <input value={finalAns} onChange={e => setFinalAns(e.target.value)} style={styles.input} />
            <button onClick={checkFinal} style={styles.button}>Check Final Answer</button>
            <p style={{ ...styles.feedback, color: finalFeedback.includes('Woohoo') ? 'green' : 'red' }}>{finalFeedback}</p>
          </div>
        )}
      </div>
      <canvas ref={canvasRef} style={styles.confetti}></canvas>
    </div>
  );
}

const styles = {
  body: {
    fontFamily: "'Comic Sans MS', cursive",
    backgroundColor: '#fff8e1',
    textAlign: 'center',
    padding: 30,
    minHeight: '100vh',
    boxSizing: 'border-box',
  },
  container: {
    background: '#ffffff',
    borderRadius: 20,
    padding: 30,
    maxWidth: 600,
    margin: 'auto',
    boxShadow: '0 0 15px rgba(0,0,0,0.2)',
  },
  h1: {
    color: '#ff6f00',
    fontSize: '2rem',
  },
  input: {
    fontSize: 18,
    padding: 10,
    margin: '0 auto',
    marginTop: 10,
    borderRadius: 10,
    width: 100,
    textAlign: 'center',
    border: '2px solid #ffcc80',
  },
  button: {
    fontSize: 18,
    padding: '10px 20px',
    margin: 10,
    borderRadius: 10,
    backgroundColor: '#ff6f00',
    color: 'white',
    border: 'none',
    cursor: 'pointer',
  },
  step: {
    margin: '20px 0',
  },
  feedback: {
    fontWeight: 'bold',
    fontSize: '1.2rem',
  },
  confetti: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    zIndex: 1000,
  },
};
